import SuperRepository from '../superRepository'

export default new (class OfferPartnerRegistrationDaysHistoryRepository extends SuperRepository {
  baseUri() {
    return 'offer_partner_registration_day_history'
  }
  updateRegistrationDaysHistory = async ({ id, ...params }) =>
    this.httpClient().put(`${this.baseUri()}/${id}`, params)
})()